var map = {
	"./20230713-Noah-Kristel-10.26-04.mp3": 9284,
	"./20230713-Noah-Kristel-10.5-05.mp3": 8372,
	"./20230713-Noah-Kristel-14.1-03.mp3": 9818,
	"./20231026_Quiz-Suzanne-01.mp3": 4542,
	"./Aansprakelijkheidsverzekering10.mp3": 9997,
	"./Eindquiz - Suzanne-01.10-05.mp3": 4888,
	"./Eindquiz - Suzanne-01.2-01.mp3": 4049,
	"./Eindquiz - Suzanne-01.8-04.mp3": 6738,
	"./Eindquiz - Suzanne-05.1-06.mp3": 9643,
	"./Eindquiz - Suzanne-06.3-08.mp3": 2142,
	"./Eindquiz - Suzanne-06.5-09.mp3": 5349,
	"./Eindquiz - Suzanne-06.8-07.mp3": 6204,
	"./Noah - Kristel-13.13-49.mp3": 9721,
	"./Noah - Kristel-13.22-52.mp3": 1081,
	"./Noah - Kristel-13.24-53.mp3": 1334,
	"./Noah - Kristel-13.26-54.mp3": 6083,
	"./Noah - Kristel-13.28-55.mp3": 8700,
	"./Noah - Kristel-13.30-56.mp3": 9906,
	"./Noah - Kristel-13.32-57.mp3": 6349,
	"./Noah - Kristel-13.36-58.mp3": 3602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 765;